import {getTestProps} from '@benchling/js-test-utils';
import React from 'react';

import {CalendarRequest} from 'calendar/CalendarConstants';
import FileBrowserActions from 'file-browser/FileBrowserActions';
import {unpackRequestAssignees} from 'requests/RequestCalendarUtils';
import {AvatarSize} from 'ui-library/avatar/AvatarConstants';
import {FloatingPlacement} from 'ui-library/floating-ui/FloatingConstants';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import PartyAvatarList from 'ui-library/PartyAvatarList';

import CalendarUtil from './CalendarUtil';

function getAssigneeText(assigneeNames: Array<string>, maxToDisplay: number): string {
  return assigneeNames.length > maxToDisplay
    ? `${assigneeNames.slice(0, maxToDisplay).join(', ')}...`
    : assigneeNames.join(', ');
}

// TODO(haroon): decouple styles from entry namespace
export default function RequestSummary(props: {request: CalendarRequest}): JSX.Element {
  return (
    <div className="u-spacing-bottom" {...getTestProps({component: 'RequestSummary', element: 'root'})}>
      <div className="entryExcerpt-header u-lr-split">
        <div
          className="u-pointer"
          onClick={() => {
            FileBrowserActions.openFile(props.request.id);
          }}
          {...getTestProps({component: 'RequestSummary', element: 'name'})}
        >
          <BenchlingIcon icon="request" className="u-mini-spacing-right" />
          {props.request.name}
        </div>
        <PartyAvatarList
          size={AvatarSize.XXSMALL}
          maxAvatars={3}
          parties={CalendarUtil.getItemParties(props.request)}
          tooltipPlacement={FloatingPlacement.TOP}
        />
      </div>
      <div>
        <div className="entryExcerpt-previewText">
          Assigned to:&nbsp;
          {getAssigneeText(
            unpackRequestAssignees(props.request.assignees).map(({name}) => name),
            5
          )}
        </div>
      </div>
    </div>
  );
}
